/**
 * @file Form送信
 */
'use strict';
// utility class
import Common from '../util/_common';


// 個別処理ファイルの読み込み
import FormReserve from './form/_form-reserve';
import FormJoin from './form/_form-join';
import FormEdit from './form/_form-edit';
import FormCart from './form/_form-cart';

/**
 * @classname FormSubmitView
 * @classdesc フォームサブミット
 */
export default class FormSubmitView {
	/**
	 * @constructor
	 * @param {object} controller - コントローラー
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 */
	constructor($e, controller) {
		console.log('FormSubmitView.constructor');
		this._controller = controller;
		this._$e = $e;
		this._form = $e.attr('data-form');
		this._$form = $('#' + this._form);
		this._process = $e.attr('data-process');
		this._timing = $e.attr('data-timing');
		this._submit = true;
		if(this._process === 'true') {
			// 個別処理ファイルのアクティベート
			switch(this._form){
				case 'form-reserve':
					this._processing = new FormReserve(controller);
					break;
				case 'form-join':
					this._processing = new FormJoin(controller);
					break;
				case 'form-edit':
					this._processing = new FormEdit(controller);
					break;
				case 'form-cart':
					this._processing = new FormCart(controller);
					break;
			}
		}

		this._$e.on('click', (e) => {
			e.preventDefault();
			if($e.hasClass('disabled')) return;
			if(!$e.hasClass('clicked')){
				$e.addClass('clicked');
				$e.append('<i class="fa fa-spinner fa-pulse ml-2">');
				this.onClick();
			}
		});
		this._controller.on('completePreProcessing', () => {this.validate();});
		this._controller.on('completeValidate', () => {this.completeValidate();});
		this._controller.on('completePostProcessing', () => {this.addMinutes();});
		this._controller.on('initialize', () => {this.initialize();});
		this._controller.on('waitCallback', () => {this.onWaitCallback();});
	};


	/**
	 * クリックのコールバック
	 *
	 * @memberof FormSubmitView
	 * @return {undefined}
	 */
	onClick() {
		console.log('FormSubmitView.onClick');
		if($('html').hasClass('product-detail')){
			if($('.block-option-select').length && !$('#radio-off').prop('checked') && !$('#radio-on').prop('checked')){
				$('.block-has-option').find('.error-tip').addClass('show').find('.error-tip-inner').text('この項目は必須です。').css({'white-space': 'nowrap', 'bottom': '43px', 'left': '20px'});
				Common.showErrorModal('未選択の項目があります');
				this.initialize();
				return;
			}
		}
		if(this._process === 'true'){
			if(this._timing === 'pre' || this._timing === 'both') {
				console.log('前処理実施');
				this._processing.preProcessing(this._$form);
			}else{
				console.log('前処理SKIP');
				this.validate(this._$form);
			}
		}else{
			console.log('前処理SKIP');
			this.validate(this._$form);
		}
	};


	/**
	 * バリデーションチェック
	 *
	 * @memberof FormSubmitView
	 * @return {undefined}
	 */
	validate() {
		console.log('FormSubmitView.validate');
		console.log('バリデーションチェック');
		this._controller.validate(this._$form);
	};


	/**
	 * バリデーション完了
	 *
	 * @memberof FormSubmitView
	 * @return {undefined}
	 */
	completeValidate() {
		console.log('FormSubmitView.completeValidate');
		console.log('バリデーション完了');
		console.log('エラーチェック');
		if(this._$form.find('.validate').hasClass('is-invalid')) this._submit = false;
		if(this._submit){
			this.postProcessing();
		}else{
			Common.showErrorModal('入力項目に誤りがあります');
			this.initialize();
		}
	};


	/**
	 * 後処理
	 *
	 * @memberof FormSubmitView
	 * @return {undefined}
	 */
	postProcessing() {
		console.log('FormSubmitView.postProcessing');
		if(this._process === 'true'){
			if(this._timing === 'post' || this._timing === 'both') {
				console.log('後処理実施');
				this._processing.postProcessing(this._$form);
			}else{
				console.log('後処理SKIP');
				this.addMinutes();
			}
		}else{
			console.log('後処理SKIP');
			this.addMinutes();
		}
	};


	/**
	 * 分を追加する
	 *
	 * @memberof FormSubmitView
	 * @return {undefined}
	 */
	addMinutes() {
		console.log('FormSubmitView.addMinutes');
		$('input[data-time=true]').each(function(){
			let val = $(this).val();
			if(val.length === 16){
				val += ':00';
				console.log(val);
				$(this).val(val);
			}
		});
		this.submit();
	};


	/**
	 * submit
	 *
	 * @memberof FormSubmitView
	 * @return {undefined}
	 */
	submit() {
		console.log('FormSubmitView.submit');
		$('.ignore-validate').removeAttr('name');
		setTimeout(() => {Common.submit(this._$form);},100);
		setTimeout(() => this.initialize(), 2000);
	};


	/**
	 * 初期化
	 *
	 * @memberof FormSubmitView
	 * @return {undefined}
	 */
	initialize() {
		console.log('FormSubmitView.initialize');
		this._submit = true;
		this._controller._$form = null;
		this._$e.removeClass('clicked').find('i').remove();
	};


	/**
	 * 初期化
	 * GMO通信時のエラー対応
	 *
	 * @memberof FormSubmitView
	 * @return {undefined}
	 */
	onWaitCallback() {
		console.log('FormSubmitView.onWaitCallback');
		this._submit = true;
		this._controller._$form = null;
	};
}
